import React from 'react';
import styled, { keyframes } from 'styled-components';
import { registry } from '../../core/Registry.js';

const marqueeAnim = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  background: ${props => props.bg || 'var(--accent)'};
  color: ${props => props.color || '#fff'};
  font-weight: 800;
  text-transform: uppercase;
  font-size: ${props => props.fontSize || '16px'};
  padding: ${props => props.padding || '15px 0'};
  white-space: nowrap;
  display: flex;
`;

const Track = styled.div`
  display: flex;
  min-width: 200%;
  animation: ${marqueeAnim} ${props => props.speed || '15s'} linear infinite;
`;

const Item = styled.span`
  padding: 0 40px;
  display: flex;
  align-items: center;
  gap: 15px;
  
  &::before {
    content: '⚡';
    font-size: 1.2em;
  }
`;

const TickerTapeWidget = ({ node }) => {
  const text = node.content?.text || 'Black Friday Sale - Bis zu 50% auf alle O2 Mobile Tarife sparen!';
  const repeats = Array(6).fill(null);

  return (
    <Wrapper bg={node.style?.desktop?.bg} color={node.style?.desktop?.color} fontSize={node.style?.desktop?.fontSize} padding={node.style?.desktop?.padding}>
      <Track speed={node.style?.desktop?.speed}>
        {repeats.map((_, i) => <Item key={i}>{text}</Item>)}
      </Track>
    </Wrapper>
  );
};

registry.register('ticker_tape', {
  label: 'News Ticker',
  icon: '🎞️',
  category: 'dynamic',
  defaultContent: {},
  defaultStyle: { desktop: { bg: 'var(--accent)', color: '#fff', fontSize: '18px', padding: '15px 0', speed: '20s' } },
  render: TickerTapeWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Text', fields: [{name:'content.text', label:'Lauftext', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Optik', fields: [{name:'style.desktop.bg', label:'Hintergrund', type:'text'}, {name:'style.desktop.color', label:'Schriftfarbe', type:'text'}, {name:'style.desktop.fontSize', label:'Schriftgröße', type:'text'}, {name:'style.desktop.speed', label:'Speed (z.B. 10s)', type:'text'}] }] }
  ]
});
